<template>
    <van-tabs :class="['tabs-box', tabActive === 0 ? 'leftActive' : 'rightActive']" :ellipsis="false" v-model="tabActive" @change="onClickTab">
        <van-tab v-for="(item, index) in tabList" :key="index" :title-class="['tabs-title', tabActive !== index ? 'active' : '']">
            <template #title>
                <div class="title">{{item.title}}</div>
                <p class="desc">{{item.desc}}</p>
            </template>
            <rights :activeItems="openItems" :listLength="listLength" @setTracked="setTracked"></rights>
        </van-tab>
    </van-tabs>
</template>

<script>
import { Tab, Tabs,Toast, Icon } from 'vant';
import { toPage, randomString } from "@/utils/tools";
import rights from './rights.vue'

export default {
    name: 'tabRights',
    props: {
        notices: {
            type: Array,
            default: () => []
        }
    },
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Icon.name]: Icon,
        rights
    },
    data() {
        return {
            tabActive: 0,
            openItems: [1,2],
            listLength: 2,
            tabList: [
                {
                    title: '基础权益',
                    desc: '16-23周岁可享'
                },{
                    title: '进阶权益',
                    desc: '学信网认证可享'
                }
            ],
        }
    },
    mounted() {

    },
    methods: {
        onClickTab(index) {
            this.openItems = index ===  0 ? [1,2] : [3,4,5]
            this.listLength = index ===  0 ? 2 : 6
            console.log('tab1231235435', index)
            this.$emit('setTrack', {
                action: 'before_rightstab_click',
                label: '认证前权益tab点击',
                value: {"channel":"学生专区","scene":"公共","tabtype": index === 0 ? '基础权益' : '进阶权益'}
            })
        },
        setTracked(data) {
            this.$emit('setTrack', data)
        }
    }
}
</script>

<style lang="less" scoped>
 .tabs-box {
        margin-top: -118px;
        ::v-deep .van-tabs__wrap {
            height: auto;
        }
        ::v-deep .van-tabs__nav {
            background: transparent;
            text-align: center;
            margin-bottom: 8px;
        }
        &.leftActive {
            background: url(//file.40017.cn/appresource/image/forStudent/new/bg_tab_left@2x.png) no-repeat;
            background-size: 100% 160px;
        }
        &.rightActive {
            background: url(//file.40017.cn/appresource/image/forStudent/new/bg_tab_right@2x.png) no-repeat;
            background-size: 100% 160px;
        }
        ::v-deep .van-tabs__line {
            display: none;
        }
        .title {
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            margin-top: 10px;
        }
        .desc {
            font-size: 12px;
            font-weight: 400;
            color: #888888; 
        }
    }
</style>>
